import { Link } from 'gatsby';
import React from 'react';

export const NotificationToastBookmarkEntityMessages = {
  article: (
    <div className="text-sm">
      Saved! You can now find me in your{' '}
      <Link className="link" to="/dashboard/saved">
        dashboard
      </Link>
    </div>
  ),
  course: (
    <div className="text-sm">
      Saved! You can now find me in your{' '}
      <Link className="link" to="/dashboard/saved">
        dashboard
      </Link>
    </div>
  ),
  event: (
    <div className="text-sm">
      Saved! You can now find me in your{' '}
      <Link className="link" to="/dashboard/saved">
        dashboard
      </Link>
    </div>
  ),
  graduate_profile: (
    <div className="text-sm">
      Saved! You can now find me in your{' '}
      <Link className="link" to="/dashboard/saved">
        dashboard
      </Link>
    </div>
  ),
  opportunity: (
    <div className="text-sm">
      Saved! You can now find me in your{' '}
      <Link className="link" to="/dashboard/applications">
        dashboard
      </Link>
    </div>
  ),
  organisation: (
    <div className="text-sm">
      Following! You can now find me in your{' '}
      <Link className="link" to="/dashboard/saved">
        dashboard
      </Link>
      .
    </div>
  ),
  video: (
    <div className="text-sm">
      Saved! You can now find me in{' '}
      <Link className="link" to="/dashboard/saved">
        dashboard
      </Link>
    </div>
  )
};
